import React, { useEffect, useState } from 'react';
import API_URL from '../../apiConfig';
import './PartnersSection.css';

const PartnersSection = () => {
    const [partners, setPartners] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchPartners = async () => {
        try {
            setLoading(true);
            const res = await fetch(`${API_URL}/api/partenaires/allpartenaires`, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
                credentials: "include"
            });
            const data = await res.json();
            if (data.success) {
                setPartners(data.partenaires);
            }
        } catch (err) {
            console.error("Erreur fetching partners:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPartners();
    }, []);

    const getImgSrc = (p) => {
        if (p.linkimgPart) {
            return p.linkimgPart.startsWith('http')
                ? p.linkimgPart
                : `${API_URL}${p.linkimgPart.startsWith('/') ? '' : '/'}${p.linkimgPart}`;
        }
        return null;
    };

    const getInitials = (p) =>
        `${(p.prenomPart || '').charAt(0)}${(p.nomPart || '').charAt(0)}`.toUpperCase();

    return (
        <section className="partners-site-section py-5" id="partenaires">
            <div className="container py-lg-5">

                {/* En-tête */}
                <div className="text-center mb-5">
                    <span className="partners-label text-uppercase fw-bold small mb-2 d-block">Notre réseau</span>
                    <h2 className="section-p-title outfit fs-1 fw-bold text-dark mb-3">Nos Partenaires</h2>
                    <p className="text-muted mx-auto" style={{ maxWidth: '600px', fontSize: '0.95rem' }}>
                        Nous collaborons avec des ministères et des organisations qui partagent notre passion pour la diffusion de la Parole de Dieu.
                    </p>
                </div>

                {/* Grille de cartes */}
                {loading ? (
                    <div className="text-center py-4">
                        <div className="spinner-border text-primary"></div>
                    </div>
                ) : partners.length > 0 ? (
                    <div className="row g-4 justify-content-center mb-5">
                        {partners.map(p => (
                            <div key={p.idPart} className="col-6 col-md-4 col-lg-3">
                                <div className="partner-card">
                                    <div className="partner-card-avatar-wrap">
                                        {getImgSrc(p) ? (
                                            <img
                                                src={getImgSrc(p)}
                                                alt={`${p.prenomPart} ${p.nomPart}`}
                                                className="partner-card-img"
                                            />
                                        ) : (
                                            <div className="partner-card-initials">
                                                {getInitials(p)}
                                            </div>
                                        )}
                                    </div>
                                    <div className="partner-card-body">
                                        <h5 className="partner-card-name">{p.prenomPart} {p.nomPart}</h5>
                                        {p.descriptionPart && (
                                            <p className="partner-card-desc">{p.descriptionPart}</p>
                                        )}
                                        <span className="partner-card-badge">
                                            <i className="bi bi-patch-check-fill me-1"></i>Partenaire
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className="text-muted text-center mb-5">Aucun partenaire affiché pour le moment.</p>
                )}

                {/* Call to Action */}
                <div className="cta-partner bg-lamp-gradient p-5 rounded-5 shadow-2xl">
                    <div className="row align-items-center">
                        <div className="col-lg-8 text-center text-lg-start mb-4 mb-lg-0">
                            <h3 className="text-white fw-bold mb-2">Rejoignez l'aventure spirituelle</h3>
                            <p className="text-white mb-0" style={{ opacity: 0.8, fontSize: '0.95rem' }}>
                                Soutenez la mission et devenez un pilier dans la diffusion de la Lumière de la Parole.
                            </p>
                        </div>
                        <div className="col-lg-4 text-center text-lg-end">
                            <button className="btn-become-partner">
                                DEVENIR PARTENAIRE <i className="bi bi-heart-fill ms-2"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PartnersSection;
